"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _polished = require("polished");

var _styled = _interopRequireDefault(require("../styled"));

var _InteractionRipples = _interopRequireDefault(require("./InteractionRipples"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styled["default"].label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  line-height: 30px;\n  overflow: visible;\n  display: inline-block;\n\n  & > span {\n    display: inline-block;\n    position: relative;\n    top: 1px;\n    margin-left: 5px;\n  }\n"])));

var Input = _styled["default"].input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), _polished.hideVisually);

var Display = _styled["default"].svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 18px;\n  vertical-align: middle;\n"])));

var InnerCircle = _styled["default"].circle(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  transition: transform 250ms cubic-bezier(0.25, 0.8, 0.25, 1) 0ms;\n  transform-origin: center;\n  transform: scale(0);\n  fill: ", ";\n\n  ", ":checked + ", " & {\n    transform: scale(0.5);\n  }\n"])), function (props) {
  return props.theme.foreground;
}, Input, Display);

var OuterCircle = _styled["default"].circle(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  fill: transparent;\n  stroke-width: 3;\n\n  stroke: ", ";\n\n  @media (hover: hover) {\n    /* Hovered/focused states when _not_ checked */\n    ", ":focus + ", " &,\n    ", ":hover ", " + ", " & {\n      fill: ", ";\n    }\n\n    /* Hovered/focused states when checked */\n    ", ":hover ", ":checked + ", " &,\n    ", ":focus:checked + ", " & {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return props.theme.foreground;
}, Input, Display, Wrapper, Input, Display, function (props) {
  return (0, _polished.transparentize)(0.7, props.theme.foreground);
}, Wrapper, Input, Display, Input, Display, function (props) {
  return (0, _polished.transparentize)(0.4, props.theme.foreground);
});

var InteractionWrapper = _styled["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 3px;\n  display: inline-block;\n  position: relative;\n  overflow: visible;\n"])));
/**
 * A styled version of the `<input type="radio" />` component.
 *
 * Any props not mentioned here are passed through to the underlying `<input>` component.
 *
 * While the component can be used on its own, it's better to use it as part of `RadioGroup`,
 * which handles certain things for you.
 */
// TODO Convert to FC (note: might not be practical)


var Radio = /*#__PURE__*/function (_React$Component) {
  _inherits(Radio, _React$Component);

  var _super = _createSuper(Radio);

  function Radio() {
    var _this;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          radioGroupChangeNotifier = _this$props.radioGroupChangeNotifier;
      if (onChange) onChange(event);
      if (radioGroupChangeNotifier) radioGroupChangeNotifier(event.currentTarget.value, event);
    });

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          rest = _objectWithoutProperties(_this$props2, ["label"]);

      var inlineLabel = label ? /*#__PURE__*/React.createElement("span", null, label) : null;
      return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(InteractionWrapper, null, /*#__PURE__*/React.createElement(_InteractionRipples["default"], {
        centered: true
      }), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
        type: "radio",
        onChange: this.handleChange
      })), /*#__PURE__*/React.createElement(Display, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-3 -3 38 38"
      }, /*#__PURE__*/React.createElement(OuterCircle, {
        r: "16",
        cx: "16",
        cy: "16"
      }), /*#__PURE__*/React.createElement(InnerCircle, {
        r: "16",
        cx: "13",
        cy: "13"
      }))), inlineLabel);
    }
  }]);

  return Radio;
}(React.Component);

var _default = Radio;
exports["default"] = _default;